module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group"
  }, [_c('h1', {
    staticStyle: {
      "text-align": "center",
      "font-size": "25px",
      "color": "deepskyblue",
      "margin-top": "100px"
    }
  }, [_vm._v("This is group page!")]), _vm._v(" "), _c('mt-swipe', {
    attrs: {
      "show-indicators": false
    }
  }, [_c('mt-swipe-item', [_vm._v("1")]), _vm._v(" "), _c('mt-swipe-item', [_vm._v("2")]), _vm._v(" "), _c('mt-swipe-item', [_vm._v("3")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-27cd79c9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/group/group.vue
// module id = 55
// module chunks = 1